import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Data } from 'react-data-grid-addons';
import _ from 'lodash';
import Moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import { browserHistory, withRouter } from 'react-router';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Image, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import CashFormatter from '../Common/cashFormatter';
import ContentWrapper from '../Layout/ContentWrapper';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import { StartOfThisMonthDatePicker, DatePicker } from '../Common/datePicker';
import Spinner from '../Widgets/spinner';
import VendorBatches from '../../containers/Inventories/vendorBatches';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import purchaseManagementModals from '../Common/modals/purchaseManagement';
import checkPermission from '../Common/permissions';
import { isOCM, ROOT_URL, ROOT_API_URL, isGGI, isOLG, isCPG, isVAK, isSV, isVIP, isGFD, isBRO, 
  isCCW,
} from '../../actions/root_url';
import { moveColumnToPosition } from '../../utils'
import CheckboxFormatter from '../Common/CheckboxFormatter';
import ConfirmActionModal from '../Common/confirmActionModal';
import { setApproval, setReview } from '../../actions/purchaseReturns_actions';
import ActionTimeline from '../Common/actionTimeline';


const {
  PurchaseReturnBatch
} = purchaseManagementModals;

momentLocalizer(Moment);

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  var test =(Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}

class PurchaseReturnForm extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      isPurchaseCreditMode: false,

      files: null,

      firstRender: false,
      isCompleted: false,

      totalNetWeight: 0,
      totalPrice: 0,
      oldQty:0,
      taxValue: 0,
      discountValue: 0,
      priceType: 'FOB',
      finalPrice: 0,
      miscCostValue: 0,
      handlingCostValue: 0,
      shippingCostValue: 0,
      adjustmentCostValue: 0,
      // BinAmount: 0,
      simplifiedProducts: null,

      // defaultRefPrice: 0,
      // refPrice: 0,
      // quantity: 0,
      BinWeight: -1,

      calculatedProducts: [],

      // vendorInformationOpen: true,
      oneTimeScheduleOpen: true,
      purchaseInformationOpen: true,
      showInventoryOpen: false,
      showVendorBatchesOpen: false,

      dirty: false,

      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      selectedInventoryRow: [],

      // Set weights modal
      setWeightOpen: false,
      totalLoaded: null,
      rowChosen: -1,
      currentWeights: null,

      // Print
      returnPDFFrameLoaded: true,

      // suggest
      suggestValue: '',
      productSearchType: 'RefNum',
      filteredByItem: false,

      isPurchaseReturnBatchVisible: false,
      selectedProduct: null,
      isDefective: false,
      alertModalVisibility: false,
      alertModalCase: 'save_with_review_and_approve',
      setReviewCallback: null,
      setApproveCallback: null,
      confirmModalVisibility: false,
      isApproved: false,
      confirmModalCase: 'confirm_review',
      setConfirmCallback: null,
      setRejectCallback: null,
      setRecheckCallback: null,
      setCancelCallback: null,
    };

    this.handleMiscCostChange = this.handleMiscCostChange.bind(this);
    this.handleShippingCostChange = this.handleShippingCostChange.bind(this);
    this.handleHandlingCostChange = this.handleHandlingCostChange.bind(this);
    this.handleAdjustmentCostChange = this.handleAdjustmentCostChange.bind(this);
    this.handleDiscountChange = this.handleDiscountChange.bind(this);
    this.handleTaxChange = this.handleTaxChange.bind(this);
    this.handleUnitPriceChange = this.handleUnitPriceChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.openShowInventory = this.openShowInventory.bind(this);
    this.closeShowInventory = this.closeShowInventory.bind(this);
    this.closeShowVendorBatches = this.closeShowVendorBatches.bind(this);
    this.openShowVendorBatches = this.openShowVendorBatches.bind(this);
    this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
    this.handleKeyPressTargetSelection = this.handleKeyPressTargetSelection.bind(this);
    this.handleKeyPressTargetInput = this.handleKeyPressTargetInput.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleKeyPressMove = this.handleKeyPressMove.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.moveOffFromProductsList = this.moveOffFromProductsList.bind(this);
    this.moveToProductsListFromVendor = this.moveToProductsListFromVendor.bind(this);
    this.fetchPurchaseOrdersByProduct = this.fetchPurchaseOrdersByProduct.bind(this);
    this.confirmSearch = this.confirmSearch.bind(this);
  }

  componentWillMount() {
    // is purchase credit mode
    if (this.context.router.routes[1].path === 'purchaseReturn/newCredit') {
      this.setState({
        isPurchaseCreditMode: true,
      });
    }
  }

  componentDidMount() {
    // purchase return mode
    const { currentPurchaseReturn } = this.props;
    if (currentPurchaseReturn) {
      this.fetchPurchaseReturn();
    } else {
      this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '');
      this.props.fetchActiveVendors();
      this.props.fetchPaymentTerms();
      this.props.fetchWarehouses();
      this.props.setDefaultOfForm('SearchType', isBRO ? 'Name' : 'RefNum', 'purchaseReturnForm')
      this.props.setDefaultOfForm('PostingDate', new Date(), 'purchaseReturnForm')
      this.props.setDefaultOfForm('ConvertItemPrice', 'FOB', 'purchaseReturnForm')
    }
    // making a leaving hook to confirm leaving
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    if(isOLG) {
      this.props.changeFormValue('ShippingMethod', { value: "Pickup", label: "Pickup" });
      this.props.changeFormValue('Pickup_Warehouse_id', {value: 1, label: 'Olong Trading Inc. '});
    }
    if (isVAK) {
      this.props.fetchBaseUsers();
    }
  }

  componentDidUpdate() {
  }

  fetchPurchaseReturn = () => {
    const { currentPurchaseReturn } = this.props;
    this.props.fetchPurchaseReturnDetail(currentPurchaseReturn.PurchaseReturn_id, currentPurchaseReturn.Return_PurchaseCompleted_id)
      .then(() => {
        this.props.fetchActiveVendors();
        this.props.fetchPaymentTerms();
        this.props.fetchWarehouses();
        this.props.setDefaultOfForm('SearchType', isBRO ? 'Name' : 'RefNum', 'purchaseReturnForm')
      })
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
      this.props.setDefaultOfForm('TaxRate', 0, 'purchaseReturnForm')
    }
    if(nextProps.miscCostValue != this.props.miscCostValue) {
      this.calculatePricesChange(nextProps.miscCostValue || 0, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue)
    }
    if(nextProps.handlingCostValue != this.props.handlingCostValue) {
      this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue || 0, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue)
    }
    if(nextProps.adjustmentCostValue != this.props.adjustmentCostValue) {
      this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount, nextProps.adjustmentCostValue || 0)
    }
    if(nextProps.shippingCostValue != this.props.shippingCostValue) {
      this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue || 0, nextProps.discount, nextProps.adjustmentCostValue)
    }
    if(nextProps.discount != this.props.discount) {
      this.calculatePricesChange(nextProps.miscCostValue, nextProps.handlingCostValue, nextProps.shippingCostValue, nextProps.discount || 0, nextProps.adjustmentCostValue)
    }
    if (nextProps.dirty != this.props.dirty) {
      this.setState({
        dirty: nextProps.dirty
      });
    }

    // Once user select a vendor, load its address and contacts.
    if (nextProps.vendorsValue && nextProps.vendorsValue != this.props.vendorsValue) {
      if (this.refs.Products && !this.state.firstRender) {
        this.refs.Products.getRenderedComponent().props.fields.removeAll();
      }
      if (nextProps.vendorsValue != null) {
        this.props.fetchVendorDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
        // this.props.fetchVendorInventoryDetail(nextProps.vendorsValue.value || nextProps.vendorsValue);
      }
      if (this.state.firstRender) this.state.firstRender = false
      if(!this.props.currentPurchaseReturnDetail) {
        let index = _.findIndex(this.props.vendors, {Vendor_id: nextProps.vendorsValue.value || nextProps.vendorsValue})
        if(index > -1) {
          let paymentTerm_id = this.props.vendors[index].PaymentTerm_id
          this.props.setDefaultOfForm('PaymentTerm_id', paymentTerm_id, 'purchaseReturnForm');
        }
      }
    }

    // Also, if vendor has been chosen in the template user'll work on, load related products.
    if (nextProps.currentPurchaseReturnDetail != this.props.currentPurchaseReturnDetail && nextProps.currentPurchaseReturnDetail) {
      const  currentPurchaseReturnDetail = nextProps.currentPurchaseReturnDetail;
      let newTotalNetWeight = 0;
      if(currentPurchaseReturnDetail.Purchase_Return_Line != null){
        currentPurchaseReturnDetail.Purchase_Return_Line.map(
          (line) => {
            line["Name"] = line.Product_id.Name;
            line["ProductNum"] = line.Product_id.ProductNum;
            line["Description"] = line.Product_id.Description;
            line["MeasureUnit"] = line.Product_id.MeasureUnit;
            line["NetWeight"] = line.Product_id.NetWeight;
            line['PackageType'] = line.Product_id.PackageType;
            line['PackageSize'] = line.Product_id.PackageSize;
            line["TotalNetWeight"] = line.TotalNetWeight;
            line["RefNum"] = line.Product_id.RefNum;
            line["ProductUnitOfMeasure"] = line.Product_id.MeasureUnit;
            line["CRV"] = line.Product_id.CRV;
            line["WarehouseZone"] = line.ZoneName;
            line["WarehouseBin"] = line.BinName;
            line['ProductType'] = line.Product_id.ProductType;
            line["Product_id"] = line.Product_id.Product_id;
            newTotalNetWeight += line.TotalNetWeight;
          }
        )
        let newTotalPrice = currentPurchaseReturnDetail.TotalPrice;
        let finalPrice = currentPurchaseReturnDetail.FinalPrice;
        let taxValue = currentPurchaseReturnDetail.TaxRate;
        let discountValue = currentPurchaseReturnDetail.Discount;
        this.setState({
          rows: currentPurchaseReturnDetail.Purchase_Return_Line,
          totalNetWeight: newTotalNetWeight,
          totalPrice: newTotalPrice,
          finalPrice: finalPrice,
          taxValue: taxValue,
          discountValue: discountValue
        });
      } else if(currentPurchaseReturnDetail.Purchase_Return_Line_Completed != null){
        currentPurchaseReturnDetail.Purchase_Return_Line_Completed.map(
          (line) => {
            line["Name"] = line.ProductName;
            line["Description"] = line.ProductDescription;
            // line["MeasureUnit"] = line.ProductUnitOfMeasure;
            // line["NetWeight"] = line.Product_id.NetWeight;
            // line["TotalNetWeight"] = (line.Product_id.NetWeight)*(line.Rtn_Quantity);
            line["RefNum"] = line.ProductRefNum;
            line["CRV"] = line.Product_id.CRV;
            // line["Product_id"] = line.Product_id.Product_id;
            // line["WarehouseZone"] = line.WarehouseZone_id.Name;
            // line["WarehouseBin"] = line.WarehouseBin_id.Name;
            newTotalNetWeight += line.TotalNetWeight;
          }
        )
        let newTotalPrice = currentPurchaseReturnDetail.TotalPrice;
        let finalPrice = currentPurchaseReturnDetail.FinalPrice;
        let taxValue = currentPurchaseReturnDetail.TaxRate;
        let discountValue = currentPurchaseReturnDetail.Discount;
        this.setState({ rows: currentPurchaseReturnDetail.Purchase_Return_Line_Completed,
          totalNetWeight: newTotalNetWeight,
          totalPrice: newTotalPrice,
          finalPrice: finalPrice,
          taxValue: taxValue,
          discountValue: discountValue,
          isCompleted: true
        });
      }
      this.setState({firstRender: true});
    }

    if (!nextProps.vendorsValue) {
      this.props.resetCurrentVendor();
    }

    if(nextProps.priceTypeValue != this.props.priceTypeValue ) {
      this.setState({ priceType: nextProps.priceTypeValue });
    }

    if (nextProps.purchaseReturnPdf && nextProps.purchaseReturnPdf !== this.props.purchaseReturnPdf) {
      this.setState({ returnPDFFrameLoaded: false });
    }

      // Calculate the sum of the price and weight for products.

      // if (nextProps.products[0] && nextProps.productsValue) {
      //
      //     let { products } = nextProps;
      //
      //     let calculatedProducts = nextProps.productsValue;
      //
      //     function round(value, decimals) {
      //         return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
      //     }
      //
      //     // calculatedProducts.map(
      //     //     product => {
      //     //         if(product.Product_id) {
      //     //             const index = _.findIndex(products, { 'Product_id': product.Product_id.value || product.Product_id });
      //     //             if(index > -1){
      //     //                 product['Title'] = products[index].Name+' No. '+ products[index].ProductNum;
      //     //                 product['TotalNetWeight'] = ((parseFloat(products[index].NetWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
      //     //                 product['TotalShippingWeight'] = ((parseFloat(products[index].ShippingWeight) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
      //     //                 product['TotalPrice'] = ((parseFloat(product.FOBUnitPrice) || 0) * (parseFloat(product.Quantity) || 0)).toFixed(2);
      //     //             }
      //     //         } else {
      //     //             product['Title'] = "Please Choose a Product";
      //     //             product['TotalNetWeight'] = 0;
      //     //             product['TotalShippingWeight'] = 0;
      //     //             product['TotalPrice'] = 0;
      //     //         }
      //     //         totalPrice = ( parseFloat(totalPrice) + ( parseFloat(product.TotalPrice) || 0 )).toFixed(2);
      //     //         totalShippingWeight = ( parseFloat(totalShippingWeight) + ( parseFloat(product.TotalShippingWeight) || 0 )).toFixed(2);
      //     //         totalNetWeight = ( parseFloat(totalNetWeight) + ( parseFloat(product.TotalNetWeight) || 0 )).toFixed(2);
      //     //     }
      //     // )
      //
      //     this.setState({
      //         calculatedProducts: calculatedProducts,
      //         // totalPrice: totalPrice,
      //         // totalShippingWeight: totalShippingWeight,
      //         // totalNetWeight: totalNetWeight
      //     })
      // }
    if(!this.props.searchType){
      this.props.setDefaultOfForm('SearchType', isBRO ? 'Name' : 'RefNum', 'purchaseReturnForm')
    }
    if (nextProps.selectedCompany && nextProps.selectedCompany.value !== this.props.selectedCompany.value) {
      this.props.fetchTaxRates(null, nextProps.selectedCompany.value);
    }
    if (isVAK) {
      if (nextProps.isCreating === false && this.props.isCreating === true && nextProps.created === true && this.props.created === false) {
        this.handleOnSaveSuccess();
      }
      if (nextProps.isEditing === false && this.props.isEditing === true && nextProps.edited === true && this.props.edited === false) {
        this.handleOnSaveSuccess();
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.returnPDFFrameLoaded !== this.state.returnPDFFrameLoaded && this.state.returnPDFFrameLoaded == false) {
      return false;
    }
    return true;
  }

  loadBatches = (batches) => {
    const { selectedProduct } = this.state;
    const rows = [...this.state.rows];
    rows.splice(selectedProduct.idx, 1);
    const newBatchRows = batches.map(batch => ({
      ...selectedProduct,
      ...batch,
      Rtn_Quantity: batch.return_quantity,
      batch_id: batch.id,
      batch_num: batch.batch_num,
    }));
    const newRows = [...rows, ...newBatchRows].map((row, idx) => ({ ...row, idx }));
    this.setState({
      rows: newRows,
    })
    this.setPurchaseReturnBatchVisibility();
  }

  // If the form is dirty, ask for confirmation.
  routerWillLeave(nextLocation) {
    if (this.state.dirty) return <Translate value="work_not_saved_warning" />;
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  closeSetWeight = () => {
    this.setState({ setWeightOpen: false });
  }

  openSetWeight = () => {
    this.setState({ setWeightOpen: true });
  }

  setWeights = (currentRow, currentWeights) => {
    const Weights = [];
    currentWeights.map(row => {
      Weights.push(+roundTo(parseFloat(row.Weight), 2).toFixed(2));
    });
    const rows = [...this.state.rows];
    rows[currentRow].Weights = Weights;
    this.setState({ rows });
  }

  keepLoaded = (oldLoaded) => {
    const rows = [...this.state.rows];
    rows[this.state.currentRow].Rtn_Quantity = oldLoaded;
    this.setState({ rows });
  }

  returnTotalWeight(totalWeight) {
    const rows = [...this.state.rows];
    const {
      Rtn_Quantity,
      FOBUnitPrice,
      SmallUnitPrice,
      ConvertNum,
    } = rows[this.state.currentRow];

    rows[this.state.currentRow].TotalNetWeight = +roundTo(totalWeight, 4).toFixed(2);
    if (rows[this.state.currentRow].ProductType === 'Fixed') {
      if (isGGI) {
        rows[this.state.currentRow].TotalPrice = +roundTo(parseFloat(Rtn_Quantity) * SmallUnitPrice * ConvertNum, 2).toFixed(2);
      } else {
        rows[this.state.currentRow].TotalPrice = +roundTo(parseFloat(Rtn_Quantity) * FOBUnitPrice, 2).toFixed(2);
      }
    } else {
      if (isGGI) {
        rows[this.state.currentRow].TotalPrice = +roundTo(totalWeight * SmallUnitPrice, 2).toFixed(2);
        rows[this.state.currentRow].FOBUnitPrice = +roundTo((totalWeight/Rtn_Quantity) * SmallUnitPrice, 2).toFixed(2);
      } else {
        rows[this.state.currentRow].TotalPrice = +roundTo(totalWeight * FOBUnitPrice, 2).toFixed(2);
      }
    }
    this.setState({ rows, BinWeight: -1 });
  }

  title() {
    if (!this.props.params.id) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="create_purchase_return" />
          </Breadcrumb.Item>
        </Breadcrumb>
      )
    }
    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="purchase_management" />
        </Breadcrumb.Item>
        <Breadcrumb.Item active="true">
          <Translate value="edit_purchase_return" />
        </Breadcrumb.Item>
      </Breadcrumb>
    )
  }

  orderHeader() {
    return (
      <div>
        <h2 style={{ cursor: "pointer" }} ><Translate value="your_return_order" /></h2>
      </div>
    )
  }

  getVendorBatches() {
    this.openShowVendorBatches();
    this.props.getVendorBatches(this.props.vendorsValue.value || this.props.vendorsValue, isVAK && this.state.isDefective);
  }

  // Render Select options dynamically with the information on the server.
  renderVendors() {
    if (this.props.vendorIsLoading) return <Spinner/> // If vendor is loading, show a spinner.
    else {
      let vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
      let vendorNumOptions = this.getVendorNumOptions();
      return (
        <Row className="marginBottomStyle">
          <Col sm={ 12 }>
            <Row><Col sm={9}>
              <label><Translate value="vendor_no" /></label>
            </Col></Row>
            <Row>
              <Col sm={ 8 }>
                <Field name="Vendor_id" component={Selection} matchPos="any" options={vendorNumOptions}/>
              </Col>
            </Row>
          </Col>
          <br/>
        </Row>
      )
    }
  }
  handleToggleDefective = () => this.setState({ isDefective: !this.state.isDefective })
  renderVendorInfo(isCompleted) {
    let vendorNameOptions =[]; // Return a JSON in the format of React-Select's options
    let vendorNumOptions = [];
    let vendorTelOptions = [];
    if (this.props.vendorIsLoading && !this.props.vendorError){
      vendorNameOptions = [{value: "Loading", label: "Loading"}]; // Return a JSON in the format of React-Select's options
      vendorNumOptions = [{value: "Loading", label: "Loading"}];
      vendorTelOptions = [{value: "Loading", label: "Loading"}];
    } // If vendor is loading, show a spinner.
    else if (this.props.vendorError) return <div><Translate value="error" /></div> // If vendor is loading, show a spinner.
    else {
      vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
      vendorNumOptions = this.getVendorNumOptions();
      vendorTelOptions = this.getVendorTelOptions();
      return (
        <Col xs={ 5 } id="vendor-info">
          <h4><Translate value="vendor_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="name" /> <span className="asteriksReq" >*</span>
            </label>
            <div className="col-xs-8">
              <Field name="Vendor_id" component={Selection} matchPos="any" options={vendorNameOptions} disabled={isCompleted}/>
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="vendor_no" />
            </label>
            <div className="col-xs-8">
              <Field name="Vendor_id" component={Selection} matchPos="any" options={vendorNumOptions} disabled={isCompleted}/>
            </div>
          </div>
          <div className="form-group">
            <div className="col-xs-5">
              {
                !this.state.isPurchaseCreditMode &&
                <Button bsStyle="primary" type="button" disabled={!this.props.vendorsValue} onClick={() => { this.getVendorBatches(); }}>
                  <Translate value="search_vendor_batches" />
                  <em className="fa fa-search" style={{ 'margin-left': '10px' }} />
                </Button>
              }
            </div>
            {
              !this.state.isPurchaseCreditMode && isVAK && <div className="col-xs-6" onClick={this.handleToggleDefective}>
                <div className="col-xs-1">
                  <CheckboxFormatter checked={this.state.isDefective} handleOnClick={this.handleToggleDefective}/>
                </div>
                <label className="col-xs-5">
                  <Translate value="is_defective"/>
                </label>
              </div>
            }
          </div>
        </Col>
      )
    }
  }

  renderBillingInfo() {
    let currentVendorDetail = this.props.currentVendorDetail;
    let contact = null;
    let phone = null;
    if(currentVendorDetail && currentVendorDetail.Billing) {
      contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName
      phone = currentVendorDetail.Billing.Telephone
    }
    return (
      <Col xs={ 4 } id="billing-info">
        <h4><Translate value="billing_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="contact" />:
            </label>
            <div className="col-xs-9">
              <Row>
                {this.props.currentVendorDetail && contact}
              </Row>
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="phone" />:
            </label>
            <div className="col-xs-9">
              <Row>
                {!this.props.currentVendorDetail && <div className="col-xs-9">
                  <Translate value="" />
                </div>}
                {this.props.currentVendorDetail && phone}
              </Row>
            </div>
          </div>
          <div className="form-group mb0">
            <label className="col-xs-3">
              <Translate value="address" />:
            </label>
            {this.props.currentVendorDetail &&
              <div className="col-xs-9">
                <Row>
                  {this.renderBillingAddress1()}
                </Row>
                <Row>
                  {this.renderBillingAddress2()}
                </Row>
              </div>
            }
          </div>
        </Col>
      )
    }

    renderReturnOrderInfo() {
      let returnReasonOptions = [
          { value: "Damaged", label: "Damaged" },
          { value: "Defective", label: "Defective" },
          { value: "No Need", label: "No Need" },
          { value: "Repair", label: "Repair" },
          { value: "Wrong Item", label: "Wrong Item" },
          { value: "Missing", label: "Missing" },
          { value: "Other", label: "Other" },
          { value: "Out", label: "Out" },
          { value: "Short", label: "Short" },
      ];
      return (
        <Col xs={ 3 } id="purchase-return-dates">
          <h4><Translate value="return_order_info" /></h4>
          <div className="form-group">
            <label className="col-xs-6">
              <Translate value="return_date" /><span className="asteriksReq">*</span>
            </label>
            <div className="col-xs-6">
              <Field name="PostingDate" component={isOLG ? DatePicker : StartOfThisMonthDatePicker} disabled={this.state.isCompleted}/>
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-6">
              <Translate value="return_reason" /><span className="asteriksReq" >*</span>
            </label>
            <div className="col-xs-6">
              <Field name="ReturnReason" component={Selection} matchPos="any" options={returnReasonOptions} disabled={this.state.isCompleted}/>
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-6">
              <Translate value="memo_no" />
              {
                (isCPG || isVIP) && <span className="asteriksReq" >*</span>
              }
            </label>
            <div className="col-xs-6">
              <Field name="MemoNum" component={InputField} matchPos="any" disabled={this.state.isCompleted}/>
            </div>
          </div>
        </Col>
      )
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ returnPDFFrameLoaded: true });
    }

    renderPrintIframe() {
      const { returnPDFFrameLoaded } = this.state;
      const { purchaseReturnPdf } = this.props;
      return (
        <PrintIframe
          id="returnPDF"
          loaded={returnPDFFrameLoaded}
          name="returnPDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={purchaseReturnPdf}
          title={<Translate value="print_purchase_return" />}
        />
      );
    }

    renderBillingAddress1() {
      const { currentVendorDetail } = this.props;
      if(currentVendorDetail && currentVendorDetail.Billing) {
        const Address1 = currentVendorDetail.Billing.Street;
        return Address1;
      }
    }

    renderBillingAddress2() {
      const { currentVendorDetail } = this.props;
      if(currentVendorDetail) {
        const Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
        return Address2;
      }
    }

    // Push vendor name and number in to 2 JSON arrays.
    getVendorNameOptions() {
      var vendorNameOptions = [];
      this.props.vendors.map(vendor => {
          vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
      });
      return vendorNameOptions;
    }

    getVendorNumOptions() {
      let vendorNumOptions = [];
      this.props.vendors.map(vendor => {
        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
      });
      return vendorNumOptions;
    }

    getVendorTelOptions() {
      let vendorNumOptions = [];
      this.props.vendors.map(vendor => {
        vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone })
      });
      return vendorNumOptions;
    }

    renderBillingAddress() {
      const { vendorsValue, currentVendorDetail } = this.props;
      if(currentVendorDetail) {
          const BillingAddress = currentVendorDetail.Billing.Name+', '+
                                 currentVendorDetail.Billing.Street+', '+
                                 currentVendorDetail.Billing.City;
          return BillingAddress;
      }
    }

    // Once a vendor is chosen, render its shipping address and contacts
    renderVendorAddress() {
      if ( this.props.vendorDetailIsLoading && !this.props.vendorDetailError ) return <Spinner/> // If vendor is loading, show a spinner.
      else if ( this.props.vendorDetailError ) return <div>Error</div> // If vendor is loading, show a spinner.
      else if ( this.props.currentVendorDetail) {
          let vendorAddressOptions = this.getVendorAddressOptions();
          let vendorContactOptions = this.getVendorContactOptions();
           return (
             <Row>
               <Col sm={6}>
                  <Row><Col sm={ 12 }>
                    <label><Translate value="return_vendor_address" /></label>
                    <Field name="Deliver_VendorDetail_id" component={Selection} matchPos="any" options={vendorAddressOptions} />
                  </Col></Row>
              </Col>
              <Col sm={6}>
                  <Row><Col sm={ 12 }>
                    <label><Translate value="return_contact" /></label>
                    <Field name="Deliver_VendorDetail_id" component={Selection} matchPos="any" options={vendorContactOptions} />
                  </Col></Row>
                  <br/>
                  {this.renderVendorContactInformation() }
               </Col>
             </Row>
          )
      }
      else return <h4 className='centerStyle' ><Translate value="msg_please_select_a_vendor" /></h4>
    }

    getVendorAddressOptions() {
      var vendorAddressOptions = [];
      this.props.currentVendorDetail.Shipping.map(address => {
        vendorAddressOptions.push({ value: address.VendorDetail_id, label: address.AddressName+', '+address.City })
      });
      return vendorAddressOptions;
    }

    getVendorContactOptions() {
      var vendorContactOptions = [];
      this.props.currentVendorDetail.Shipping.map(contact => {
        vendorContactOptions.push({ value: contact.VendorDetail_id, label: contact.FirstName+' '+contact.LastName })
      });
      return vendorContactOptions;
    }

    renderVendorContactInformation() {
      const { currentVendorDetail, vendorsValue, vendorContactValue } = this.props;
      if(vendorContactValue && currentVendorDetail ) {
        const index = _.findIndex(currentVendorDetail.Shipping, { 'VendorDetail_id': vendorContactValue });
        if (index != -1) return (
          <div>
            <Row>
              <Col sm={ 3 }>
                <label><Translate value="name" />:</label>
              </Col>
              <Col sm={ 9 }>
                {currentVendorDetail.Shipping[index].FirstName+' '+currentVendorDetail.Shipping[index].LastName}
              </Col>
            </Row>
            <Row>
              <Col sm={ 3 }>
                <label><Translate value="email" />:</label>
              </Col>
              <Col sm={ 9 }>
                {currentVendorDetail.Shipping[index].Email}
              </Col>
            </Row>
            <Row>
              <Col sm={ 3 }>
                <label><Translate value="phone" />:</label>
              </Col>
              <Col sm={ 9 }>
                {currentVendorDetail.Shipping[index].Telephone}
              </Col>
            </Row>
          </div>
        )
      }
    }

    // Render the Array of products.

    // renderProducts() {
    //     if (!this.props.vendorsValue &&
    //         (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.Vendor_id)))
    //         return <h4>Please Select a Vendor</h4>
    //     if (this.props.productIsLoading) return <Spinner/> // If group is loading, show a spinner.
    //     else {
    //         const { miscCostValue, handlingCostValue, shippingCostValue } = this.props;
    //         let productNumOptions = this.getProductNumOptions();
    //         let productNameOptions = this.getProductNameOptions();
    //         let totalCost = (parseFloat(shippingCostValue || 0) + parseFloat(miscCostValue || 0) + parseFloat(handlingCostValue || 0)).toFixed(2)
    //         return (
    //             <FieldArray name="Purchase_Order_Line"
    //                 ref="Products"
    //                 component={ProductArrayOrder}
    //                 productNameOptions={productNameOptions}
    //                 productNumOptions={productNumOptions}
    //                 calculatedProducts={this.state.calculatedProducts}
    //                 productsValue={this.props.productsValue}
    //                 products={this.props.products}
    //                 priceType={this.state.priceType }
    //                 totalPrice={this.state.totalPrice}
    //                 totalCost={totalCost}
    //                 withRef />
    //         )
    //     }
    // }

    fetchPurchaseOrdersByProduct(productID, product) {
      this.setState({
        suggestValue: '',
      });
      this.moveToProductsListFromVendor([product]);
    }

    moveToProductsListFromAll() {
      // delete productInformation, use selectedInventoryRow instead,
      const { simplifiedProducts } = this.props;
      var selectedInventoryRow = this.state.selectedInventoryRow;
      const quantity = parseFloat(this.props.allProd_Quantity || 0);
      const index = _.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
      let refPrice = (this.props.allProd_FOBUnitPrice) || 0;
      let newProduct = {...simplifiedProducts[index]};
      newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
      newProduct["TotalNetWeight"] = (simplifiedProducts[index].NetWeight)*(quantity);
      newProduct["Rtn_Quantity"] = quantity;
      newProduct["TotalPrice"] = parseFloat(quantity*refPrice).toFixed(2);
      newProduct["WarehouseZone"] = simplifiedProducts[index].ZoneName;
      newProduct["WarehouseBin"] = simplifiedProducts[index].BinName;
      if (newProduct.ProductType === 'Non-Fixed') {
        newProduct.Weights = [];
        newProduct.TotalNetWeight = 0;
        newProduct.TotalPrice = 0;
      }
      const newRows = [...this.state.rows, newProduct];
      // let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
      // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
      this.calculatePrices(newRows)
      let allProducts = ReactDOM.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input);
      allProducts && allProducts.focus();
      this.props.resetAllProducts('purchaseReturnForm');
    }

    moveToProductsListFromVendor(products) {
      products.map(product => {
        product.Rtn_Quantity = product.BinAmount;
        product.TotalPrice = product.Rtn_Quantity * product.FOBUnitPrice;
        if (!product.FOBUnitPrice) {
          product.FOBUnitPrice = product.ProductCost;
        }
        product.TotalNetWeight = roundTo((product.BinAmount || 0) * product.NetWeight, 2);

        if(isGGI) {
          let small = 0;
          if(product.small_unit_price && product.small_unit_price != undefined) small = product.small_unit_price
          if(product.SmallUnitPrice && product.SmallUnitPrice != undefined) small = product.SmallUnitPrice
          product.SmallUnitPrice = small;
          product.FOBUnitPrice = (small * product.ConvertNum).toFixed(2);
          product.TotalPrice = (product.Rtn_Quantity * small * product.ConvertNum).toFixed(2);
        }
        if (product.ProductType === 'Non-Fixed') {
          product.Weights = [];
          product.TotalNetWeight = 0;
          product.TotalPrice = 0;
          if(isGGI || isOLG || isCCW) {
            product.Rtn_Quantity = 0;
          }
        }
      })
      const newRows = [...this.state.rows, ...products].map((row, idx) => ({ ...row, idx }));
      // let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
      // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
      this.calculatePrices(newRows)
      let allPr= ReactDOM.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input);
      allPr && allPr.focus();
    }

    // moveToProductsList(){
    //   const { products, productInformation } = this.props;
    //   const quantity = this.state.quantity;
    //   const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
    //   let refPrice = this.state.refPrice || this.state.defaultRefPrice || products[index].FOBUnitPrice || 0;
    //   let newProduct = {...products[index]};
    //   newProduct["Name"] = products[index].ProductName;
    //   newProduct["Description"] = products[index].ProductDescription;
    //   newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
    //   newProduct["TotalNetWeight"] = (products[index].NetWeight)*(quantity);
    //   newProduct["Rtn_Quantity"] = quantity;
    //   newProduct["TotalPrice"] = parseFloat(quantity*refPrice).toFixed(2);
    //   newProduct["WarehouseZone"] = products[index].ZoneName;
    //   newProduct["WarehouseBin"] = products[index].BinName;
    //   const newRows = [...this.state.rows, newProduct];
    //   let totalNetWeight = parseFloat(this.state.totalNetWeight) + quantity*parseFloat(newProduct["NetWeight"]);
    //   totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
    //   let totalPrice = parseFloat(this.state.totalPrice) + quantity*parseFloat(newProduct["FOBUnitPrice"]);
    //   totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
    //   let discountValue = this.state.discountValue;
    //   let taxValue = this.state.taxValue;
    //   let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
    //   this.setState({rows: newRows,
    //     totalNetWeight: totalNetWeight,
    //     totalPrice: totalPrice,
    //     finalPrice: finalPrice,
    //     defaultRefPrice: 0,
    //     refPrice: 0,
    //     BinAmount: 0,
    //     quantity: 0
    //   });
    // }

    moveOffFromProductsList(idx){
      let newRows = this.state.rows;
      // newRows = newRows.filter(function(obj){
      //   return obj.Product_id != Product_id;
      // })
      newRows.splice(idx, 1);
      newRows = newRows.map((row, idx) => ({ ...row, idx }));
      this.calculatePrices(newRows)
    }

    calculatePrices(newRows) {
      let totalPrice = 0, totalPriceForTax = 0, CRV = 0;
      newRows.map(r => {
        totalPrice += parseFloat(r.TotalPrice);
        if(r.IsTaxable) {
          totalPriceForTax += parseFloat(r.TotalPrice);
        }
        CRV += parseFloat(r.CRV || 0) * parseFloat(r.Rtn_Quantity);
      })
      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      let taxRate = this.props.taxRate;
      let miscCostValue = parseFloat(this.props.miscCostValue) || 0;
      let handlingCostValue = parseFloat(this.props.handlingCostValue) || 0;
      let adjustmentCostValue = parseFloat(this.props.adjustmentCostValue) || 0;
      let shippingCostValue = parseFloat(this.props.shippingCostValue) || 0;
      let finalPrice = (totalPrice * (1 - parseFloat(this.props.discount || 0) / 100.0) + parseFloat(totalPriceForTax) * parseFloat(taxRate || 0) / 100.0 + CRV + miscCostValue + handlingCostValue + adjustmentCostValue + shippingCostValue).toFixed(2);
      this.setState({
        rows: newRows,
        totalPriceForTax: totalPriceForTax,
        totalPrice: totalPrice,
        finalPrice: finalPrice,
        CRV: CRV,
      });
    }

    calculatePricesChange(miscCostValue, handlingCostValue, shippingCostValue, discount, adjustmentCostValue) {
      let totalPrice = 0, totalPriceForTax = 0, CRV = 0;
      this.state.rows.map(r => {
        totalPrice += parseFloat(r.TotalPrice);
        if(r.IsTaxable) {
          totalPriceForTax += parseFloat(r.TotalPrice);
        }
        CRV += parseFloat(r.CRV || 0) * parseFloat(r.Rtn_Quantity || 0);
      })
      totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
      let taxRate = this.props.taxRate;
      if(miscCostValue != 0)
        miscCostValue = parseFloat(miscCostValue) || parseFloat(this.props.miscCostValue) || 0;
      if(handlingCostValue != 0)
        handlingCostValue = parseFloat(handlingCostValue) || parseFloat(this.props.handlingCostValue) || 0;
      if(adjustmentCostValue != 0)
        adjustmentCostValue = parseFloat(adjustmentCostValue) || parseFloat(this.props.adjustmentCostValue) || 0;
      if(shippingCostValue != 0)
        shippingCostValue = parseFloat(shippingCostValue) || parseFloat(this.props.shippingCostValue) || 0;
      if(discount != 0)
        discount = parseFloat(discount) || parseFloat(this.props.discount) || 0;
      let finalPrice = parseFloat(totalPrice * (1 - parseFloat(discount || 0) / 100.0) + parseFloat(totalPriceForTax || 0) * parseFloat(taxRate || 0) / 100.0 + CRV + miscCostValue + handlingCostValue + adjustmentCostValue + shippingCostValue).toFixed(2);
      this.setState({
        totalPriceForTax: totalPriceForTax,
        totalPrice: totalPrice,
        finalPrice: finalPrice,
        CRV: CRV,
      });
    }

    // setDefault() {
    //   const { productInformation } = this.props;
    //   if(productInformation){
    //     const products = this.props.products;
    //     const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
    //     if(products[index] != null){
    //       if(this.state.defaultRefPrice != products[index].UnitPrice)
    //         this.setState({defaultRefPrice: products[index].UnitPrice});
    //       if(this.state.BinAmount != products[index].BinAmount)
    //         this.setState({BinAmount: products[index].BinAmount});
    //     }
    //   }
    // }

    handleUnitPriceChange(event) {
      this.setState({refPrice: event.target.value});
    }

    handleQuantityChange(event) {
      this.setState({quantity: event.target.value});
    }

    renderProducts() {
      if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
        let productNumOptions = this.getProductNumOptions();
        const moveOffFromProductsList = this.moveOffFromProductsList;
        // Parameters of the react-data-grid

        const getRows = () => {
          return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
          return getRows().length;
        }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the row select function
        const onRowSelect = rows => {
          this.setState(...this.state, { selectedRows: rows });
        }

        const onRowsSelected = (rows) => {
           let newRows = this.state.rows;
           rows.map (r => {
             newRows[r.rowIdx].isSelected = true;
           });
           this.setState({rows: newRows});
        }

         const onRowsDeselected = (rows) => {
           let newRows = this.state.rows;
           rows.map (r => {
             newRows[r.rowIdx].isSelected = false;
           });
           this.setState({rows: newRows});
         }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState(state);
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          this.setState({ filters: newFilters });
        }

        const onRowClick = (rowIdx, row) => {
          this.props.fetchSalesOrders();
        }

        // Handle the editable function
        const handleRowUpdated = e => {
          const rows = getRows();
          // let totalPrice = this.state.totalPrice;
          // let discountValue = this.state.discountValue;
          // let taxValue = this.state.taxValue;

          if (e.updated.Remark != null) {
            const sourceObj = {
              Remark: e.updated.Remark
            };
            Object.assign(rows[e.rowIdx], sourceObj);
          }
          if(e.updated.Rtn_Quantity != null) {
            const updatingRow = rows[e.rowIdx]
            //return qty must less or equal to batch qty
            if (e.updated.Rtn_Quantity > updatingRow.BinAmount) {
              alert(`Return Quantity Must Less Or Equal To Bin Amount ${updatingRow.BinAmount}`);
              return;
            }
            // let quantity = rows[e.rowIdx].Rtn_Quantity;
            // Object.assign(rows[e.rowIdx], e.updated);
            // Object.assign(rows[e.rowIdx], { TotalPrice: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].FOBUnitPrice).toFixed(2) });
            // Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].EstSalePrice).toFixed(2)});
            // Object.assign(rows[e.rowIdx], {TotalNetWeight: parseFloat(e.updated.Rtn_Quantity*rows[e.rowIdx].NetWeight).toFixed(2)});
            // totalNetWeight = parseFloat(this.state.totalNetWeight) + (e.updated.Rtn_Quantity-quantity)*parseFloat(rows[e.rowIdx].NetWeight);
            // totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
            // totalPrice = parseFloat(this.state.totalPrice) + (e.updated.Rtn_Quantity-quantity)*parseFloat(rows[e.rowIdx].FOBUnitPrice);
            // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
            if (rows[e.rowIdx].ProductType === 'Non-Fixed') {
              const updated = { ...e.updated };
              if (parseFloat(updated.Rtn_Quantity) < 0) {
                updated.Rtn_Quantity = 0;
              }
              let oldQty = rows[e.rowIdx].Rtn_Quantity;
              Object.assign(rows[e.rowIdx], updated);
              this.setState({
                currentRow: e.rowIdx,
                totalLoaded: parseFloat(rows[e.rowIdx].Rtn_Quantity),
                BinWeight: isCCW ? parseFloat(rows[e.rowIdx].BinWeight) : -1,
                rowChosen: e.rowIdx,
                currentWeights: rows[e.rowIdx].Weights,
                editedRow: rows[e.rowIdx],
                oldQty,
              });
              this.openSetWeight();
            } else {
              let newWeight = parseFloat(rows[e.rowIdx].NetWeight) * parseFloat(e.updated.Rtn_Quantity);
              newWeight = parseFloat(parseFloat(newWeight).toFixed(2));
              Object.assign(rows[e.rowIdx], { TotalNetWeight: newWeight });
              if(isGGI) {
                Object.assign(rows[e.rowIdx], { TotalPrice: (+roundTo(parseFloat(e.updated.Rtn_Quantity) * rows[e.rowIdx].SmallUnitPrice * rows[e.rowIdx].ConvertNum, 2).toFixed(2)) });
              } else {
                Object.assign(rows[e.rowIdx], { TotalPrice: (+roundTo(parseFloat(e.updated.Rtn_Quantity) * rows[e.rowIdx].FOBUnitPrice, 2).toFixed(2)) });
              }
              Object.assign(rows[e.rowIdx], e.updated);
            }
          } else if (e.updated.FOBUnitPrice != null) {
            // let FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
            // Object.assign(rows[e.rowIdx], e.updated);
            // Object.assign(rows[e.rowIdx], {TotalPrice: parseFloat(e.updated.FOBUnitPrice*rows[e.rowIdx].Rtn_Quantity).toFixed(2)});
            // totalPrice = parseFloat(this.state.totalPrice) + rows[e.rowIdx].Rtn_Quantity*(parseFloat(e.updated.FOBUnitPrice)-parseFloat(FOBUnitPrice));
            // totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
            if (rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.FOBUnitPrice) * rows[e.rowIdx].TotalNetWeight, 2).toFixed(2) });
            } else {
              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.FOBUnitPrice) * rows[e.rowIdx].Rtn_Quantity, 2).toFixed(2) });
            }
            Object.assign(rows[e.rowIdx], e.updated);
            this.setState({ currentWeights: rows[e.rowIdx].Weights });
          } else if(isGGI && e.updated.SmallUnitPrice != null) {
            if (rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.SmallUnitPrice) * rows[e.rowIdx].TotalNetWeight, 2).toFixed(2), FOBUnitPrice: +roundTo(parseFloat(e.updated.SmallUnitPrice) * rows[e.rowIdx].TotalNetWeight / rows[e.rowIdx].Rtn_Quantity, 2).toFixed(2)});
            } else {
              Object.assign(rows[e.rowIdx], { TotalPrice: +roundTo(parseFloat(e.updated.SmallUnitPrice) * rows[e.rowIdx].ConvertNum * rows[e.rowIdx].Rtn_Quantity, 2).toFixed(2), FOBUnitPrice: +roundTo(parseFloat(e.updated.SmallUnitPrice) * rows[e.rowIdx].ConvertNum, 2).toFixed(2)});
            }
            Object.assign(rows[e.rowIdx], e.updated);
          }
          // else if(e.updated.EstSalePrice != null){
          //   let quantity = rows[e.rowIdx].Rtn_Quantity;
          //   Object.assign(rows[e.rowIdx], e.updated);
            // Object.assign(rows[e.rowIdx], {EstSaleTotal: parseFloat(e.updated.EstSalePrice*rows[e.rowIdx].Rtn_Quantity).toFixed(2)});
          // }

          this.calculatePrices(rows);
            // // merge updated row with current row and rerender by setting state
            // let rows = this.state.rows.slice(0);
            // let editedRows = this.state.editedRows.slice(0);
            // Object.assign(rows[e.rowIdx], e.updated);
            // // if the element is already edited, remove the old one.
            //
            // editedRows.forEach((element, index) => {
            //     if (element.ProductNum === rows[e.rowIdx].ProductNum)
            //         editedRows.splice(index, 1)
            // }, this);
            // // push the row into the editedRows array
            // editedRows.push(rows[e.rowIdx]);
            // this.setState({
            //     rows: rows,
            //     editedRows: editedRows
            // });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
          render() {
            if (this.props.value) {
              let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
              let date = new Date(this.props.value)
              let index = dateMap.indexOf(date.toString().slice(4,3));
              let localDate = index + date.toString().slice(8, 6);
              return <span>{date.toString().slice(4, 15)}</span>;;
            }
            else return <span className="label label-danger">-</span>;
          }
        });

        const VendorNameFormatter = React.createClass({
          render() {
            if (this.props.value) return <span>{this.props.value.Name}</span>;
            else return <span className="label label-danger">-</span>;
          }
        });

        const VendorNumFormatter = React.createClass({
          render() {
            if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
            else return <span className="label label-danger">-</span>;
          }
        });

        const IsVariableFormatter = React.createClass({
          render() {
            return <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                type='button'
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={ () => { moveOffFromProductsList(this.props.dependentValues.idx) } }
              >
                <Translate value="X" />
              </Button>
            </span>;
          }
        });

        // Column difinition

        const columns = [
          {
            key: 'Delete',
            name: <Translate value="del" />,
            formatter: IsVariableFormatter,
            width: 50,
            getRowMetaData: (row) => row
          },
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            width: 80,
            sortable: true,
            filterable: true
          },
          {
            key: 'RefNum',
            name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
            resizable: true,
            sortable: true,
            width: 70,
            filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="prod_name" />,
            resizable: true,
            sortable: true,
            width: 200,
            filterable: true
          },
          {
            key: 'Description',
            name: <Translate value="desc" />,
            resizable: true,
            width: 120,
            sortable: true,
            filterable: true,
          },
          {
            key: 'Batch',
            name: <Translate value="batch" />,
            resizable: true,
            width: 100,
            sortable: true,
            filterable: true,
            getRowMetaData: (row) => row,
            // formatter: ({ dependentValues }) => {
            //   return <div style={{ height: '21px'}} onDoubleClick={() => {
            //     this.setState({
            //       selectedProduct: dependentValues,
            //     }, () => this.setPurchaseReturnBatchVisibility(true))
            //   }}>{dependentValues.batch_num}</div>
            // }
            formatter: ({ dependentValues }) => {
              return <span style={{ width: '100%' }} onDoubleClick={() => {
                // this.setPurchaseReturnBatchVisibility(true)
              }}>{dependentValues.Batch_PONum}</span>
            }
          },
          {
            key: 'Rtn_Quantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            width: 80,
            editable: true,
            sortable: true,
            filterable: true,
          },
          ...isGGI ?[{
            key: 'SmallUnitPrice',
            name: <Translate value="small_unit_price" />,
            resizable: true,
            width: 110,
            editable: true,
            sortable: true,
            filterable: true,
          }]:[],
          {
            key: 'FOBUnitPrice',
            name: <Translate value="unit_dollarsign" />,
            resizable: true,
            width: 80,
            editable: !isGGI,
            sortable: true,
            filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'TotalPrice',
            name: <Translate value="total_dollarsign" />,
            resizable: true,
            sortable: true,
            width: 75,
            filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'TotalNetWeight',
            name: <Translate value="total_wt" />,
            resizable: true,
            sortable: true,
            width: 75,
            filterable: true,
          },
          {
            key: 'PackageType',
            name: <Translate value="pkg_type" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true
          },
          {
            key: 'PackageSize',
            name: <Translate value="package_size" />,
            resizable: true,
            sortable: true,
            width: 90,
            filterable: true
          },
          {
            key: 'Remark',
            name: <Translate value="notation" />,
            resizable: true,
            width: 100,
            editable: true,
          },
        ];
        if (this.state.isPurchaseCreditMode) {
          columns.splice(5, 1);
        }
        if(isOLG) {
          moveColumnToPosition(columns, {key: 'ProductNum'})
        }
        return (
          <div>
          {/* <Row><Col sm={ 12 }>
              <Row><Col sm={ 12 }>
                <Panel className="panelStyle" header={this.productHeader()} >
                          <Row>
                              <Col sm={ 12 }>
                                <Row>
                                  <Col sm ={ 12 }>
                                    <Col sm = { 2 }><label><Translate value="product_num" /></label></Col>
                                    <Col sm = { 10 }>
                                      <Field name="ProductInformation" component={DetailedSelection} options={productNumOptions} onChange={this.setDefault()}/>
                                    </Col>
                                  </Col>
                                </Row>
                              <Row>
                                <Col sm={ 4 }>
                                  <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="quantity" /></label></Col>
                                  <Col sm={ 6 }>
                                        <Field name="Rtn_Quantity" component={ ControlledInputField } placeholder={this.state.quantity} onChange={this.handleQuantityChange}/>
                                  </Col>
                                </Col>
                                <Col sm={ 4 }>
                                  <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="unit_price" /></label></Col>
                                  <Col sm={ 6 }>
                                        <Field name="FOBUnitPrice" component={ ControlledInputField } placeholder={ this.state.refPrice || this.state.defaultRefPrice } onChange={this.handleUnitPriceChange}/>
                                  </Col>
                                </Col>
                                <Col sm={ 4 }>
                                      <Col sm = { 6 }><label className="col-sm-12 inlineLabel"><Translate value="BinAmount" /></label></Col>
                                      <Col sm = { 6 }> {this.state.BinAmount} </Col>
                                </Col>
                              </Row>
                              </Col>
                            </Row>
                          <br/>
                      </Panel>
              </Col></Row>
          </Col></Row> */}
        {/* <Row><Col><Button className="btn btn-primary pull-right" disabled={this.state.isCompleted} onClick={() => this.moveToProductsList() }>
              <Translate value="move_to_product_list" /></Button></Col>
            <Col><Button className="btn btn-primary pull-right" disabled={this.state.isCompleted} onClick={() => this.moveOffFromProductsList() }>
              <Translate value="move_off_from_products_list" /></Button></Col></Row> */}
            <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchaseReturnForm-dataGrid1">
              <ReactDataGrid
                rowKey='Product_id'
                enableCellSelect={true}
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={375}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowUpdated={handleRowUpdated}
              />
            </div></Col></Row>
          </div>
        )
      }
    }
    renderPurchaseReturnDetails() {
      const { Review_Status, Approve_Status, } = this.props.currentPurchaseReturnDetail || {};
      return <div className="purchase-return-details">
        <Row>
          <Col xs={4} className="pr-no-line-height">
            <label><Translate value="pr_no" /></label>
          </Col>
          <Col xs={8}>
            <Field name="PRNum" component={DisabledInputField} />
          </Col>
        </Row>
        <Row>
          <Col xs={4} className="status-line-height">
            <label><Translate value="status" /></label>
          </Col>
          <Col xs={8}>
            <Field name="ReturnStatus" component={DisabledInputField} />
          </Col>
        </Row>
        <Row>
          <Col xs={4} className="status-line-height">
            <label><Translate value="modifier" /></label>
          </Col>
          <Col xs={8}>
            <Field name="Modifier_Username" component={DisabledInputField} />
          </Col>
        </Row>
        {isVAK && <Row>
          <Col xs={12}>
            <label><Translate value="reviewer" /><span className="asteriksReq" >*</span></label>
            <Field
              name="Review_User_id" component={Selection} matchPos="any"
              options={this.props.userOptions}
              disabled={Review_Status === 'Pending' || Review_Status === 'Confirm'}
            />
          </Col>
          <Col xs={12}>
            <label><Translate value="approver" /><span className="asteriksReq" >*</span></label>
            <Field name="Approve_User_id" component={Selection} matchPos="any"
              options={this.props.userOptions}
              disabled={Approve_Status === 'Pending' || Approve_Status === 'Confirm'}
            />
          </Col>
        </Row>}
        <Row>
          {this.renderCarryTypeShippingMethod(this.state.isCompleted)}
        </Row>
        <Row>
          {this.renderWarehouse()}
        </Row>
        <Row>
          {this.renderPaymentTerms(this.state.isCompleted)}
        </Row>
        {/* <Row> */}
        {/* <Col xs={ 12 }> */}
        {/* <label>
              <Translate value="upload_image" />
            </label> */}
        {/* <Dropzone id="dropzone" onDrop={this.onDrop.bind(this)} className="well dropzone" > */}
        {/* <Button className="pull-right btn btn-default btn-primary" type='button' onClick={this.onOpenClick} disabled={this.state.isCompleted}><Translate value="upload_file" /></Button> */}
        {/* <div className="dz-default dz-message"><Translate value="msg_drop_upload_files" /></div> */}
        {/* </Dropzone> */}
        {/* {this.state.files && this.renderPreview() } */}
        {/* </Col> */}
        {/* </Row> */}
        <Row>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="shipping" /></label>
            <Col sm={12}>
              <Field name="ShippingCost" component={InputField} />
            </Col>
          </Col>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="handling" /></label>
            <Col sm={12}>
              <Field name="HandlingCost" component={InputField} />
            </Col>
          </Col>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="misc" /></label>
            <Col sm={12}>
              <Field name="MiscCost" component={InputField} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="adjust" /></label>
            <Col sm={12}>
              <Field name="Adjustment" component={InputField} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="disc" />%</label>
            <Col sm={12}>
              <Field name="Discount" component={InputField} />
            </Col>
          </Col>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="tax" />%</label>
            <Col sm={12}>
              <Field name="TaxRate" component={DisabledInputField} />
            </Col>
          </Col>
          <Col sm={4} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="crv" /></label>
            <Col sm={12}>
              <Field name="CRV" component={DisabledInputField} placeholder={this.state.CRV} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col sm={6} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel"><Translate value="total" /><span className="dollar-sign">$$</span></label>
            <Col sm={12}>{this.state.totalPrice}</Col>
          </Col>
          <Col sm={6} className="p0">
            <label className="col-sm-12 marginTopStyle inlineLabel"><Translate value="final" /><span className="dollar-sign">$$</span></label>
            <Col sm={12}>{this.state.finalPrice}</Col>
          </Col>
        </Row>
      </div>
    }

    getProductNumOptions() {
      var productNumOptions = [{value: '', label: "No.       |  Name           |  Description                         |  Batch_PONum    | Zone      | Bin"}];
      if(this.props.products) {
        this.props.products.map(product => {
            let text = "                                                                                                                                                             ";
            let output = [product.ProductNum.slice(0, 8), text].join('');
            output = [output.slice(0,8), '  |  ', product.ProductName.slice(0,12), text].join('');
            if(product.Description)
              output = [output.slice(0,26), '  |  ', product.Description.slice(0,50), text].join('');
            else
              output = [output.slice(0,26), '  |  ', '                                                  ', text].join('');
            output = [output.slice(0,62), '  |  ', product.Batch_PONum.slice(0,10), text].join('');
            output = [output.slice(0,80), '  |  ', product.ZoneName.slice(0,50), text].join('');
            output = [output.slice(0,92), '  |  ', product.BinName.slice(0,50), text].join('');
            output = output.slice(0,145);
            productNumOptions.push({ value: product.Product_id, label: output})
        });
      }
      return productNumOptions;
    }

    // Dropdown list for payment status
    renderPaymentStatus() {
      let paymentStatusOptions = [
        { value: 'Not Paid', label: 'Not Paid' },
        { value: 'Partially Paid', label: 'Partially Paid' },
        { value: 'Paid', label: 'Paid' },
      ]

      return (
        <Col sm={ 6 }>
          <label className="col-sm-6 inlineLabel" ><Translate value="payment_status" /> <span style={{color: 'red'}} >*</span> </label>
          <Col sm={ 6 }>
            <Field name="PaymentStatus" component={Selection}  matchPos="any" options={paymentStatusOptions}/>
          </Col>
        </Col>
      )
    }

    renderCarryTypeShippingMethod(isCompleted) {
      let carryTypeOptions = [
        { value: "Dry", label: <Translate value="dry" /> },
        { value: "Refrigerated", label: <Translate value="refrigerated" /> }
      ];
      let shippingMethodOptions = [
        { value: "Pickup", label: <Translate value="pickup" /> },
        { value: "Delivery", label: <Translate value="delivery" /> }
      ];
      const defaultValue = isOLG ? { value: "Pickup", label: "Pickup" } : {value: "Own Logistic", label: "Own Logistic"};
      return (
        <div>
          <Col xs={ 12 } id="shipping-method-field">
            <label>
              <Translate value="shipping_method" /><span className="asteriksReq">*</span>
            </label>
            <Field
              name="ShippingMethod"
              matchPos="any"
              component={Selection}
              options={shippingMethodOptions}
              defaultValue={defaultValue}
              disabled={isCompleted}
            />
          </Col>
          <Col xs={ 12 }>
            <label><Translate value="carry_type" /></label>
            <Field
              name="CarryType"
              matchPos="any"
              component={Selection}
              options={carryTypeOptions}
              defaultValue={{value: "Dry", label: "Dry"}}
              disabled={isCompleted}
            />
          </Col>
        </div>
      )
    }

    // Render the Paymentterms select.
    renderPaymentTerms(isCompleted) {
      if (this.props.paymentTermsIsLoading) return <Spinner/> // If group is loading, show a spinner.
      else {
        let paymentTermOptions = this.getPaymentTermOptions();
        return (
          <Col xs={ 12 }>
            <label><Translate value="payment_term" /></label>
            <Field name="PaymentTerm_id" component={Selection} matchPos="any" options={paymentTermOptions} disabled={isCompleted}/>
          </Col>
        )
      }
    }

    getPaymentTermOptions() {
      var paymentTermOptions = [];
      this.props.paymentTerms.map(paymentTerm => {
        paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
      });
      return paymentTermOptions;
    }

    // Implement the Headers which enable the function of collapsible
    productHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="product_information" /></label>
        </div>
      )
    }

    returnHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="return" /></label>
        </div>
      )
    }

    deliverHeader() {
      return (
        <Row>
          <label style={{ cursor: "pointer" }} ><Translate value="pickup_warehouse" /></label>
        </Row>
      )
    }

    carryHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="carry_type_shipping_method" /></label>
        </div>
      )
    }

    accountHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="account_payment_term" /></label>
        </div>
      )
    }

    attachmentHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="attachment_upload" /></label>
        </div>
      )
    }

    // vendorHeader() {
    //     return (
    //         <div onClick={ ()=> this.setState({ vendorInformationOpen: !this.state.vendorInformationOpen })} >
    //             <label style={{ cursor: "pointer" }} ><Translate value="vendor_information" /></label>
    //         </div>
    //     )
    // }

    oneTimeScheduleHeader(){
      return (
        <div onClick={ ()=> this.setState({ oneTimeScheduleOpen: !this.state.oneTimeScheduleOpen })} >
          <label style={{ cursor: "pointer" }} ><Translate value="one_time_schedule" /></label>
        </div>
      )
    }

    purchaseInformationHeader(){
      return (
        <div onClick={ ()=> this.setState({ purchaseInformationOpen: !this.state.purchaseInformationOpen })} >
          <label style={{ cursor: "pointer" }} ><Translate value="purchase_information" /></label>
        </div>
      )
    }

    onDrop(files) {
      this.setState({
          files: files
      });
    }

    onOpenClick() {
      this.refs.dropzone.open();
    }

    openShowInventory(event) {
      if(!(this.props.allProducts) || (this.props.allProducts=="")){
        return;
      }
      switch (event.charCode) {
        case 13: // ENTER
          event.preventDefault();
          this.props.fetchReturnBatch(this.props.searchType, this.props.allProducts);
          this.setState({showInventoryOpen: true});
          break;
      }
    }

    renderAutoSuggest() {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchPurchaseOrdersByProduct}
          />
        </div>
      );
    }

    closeShowInventory(value) {
      this.setState({ showInventoryOpen: false });
      if (value) {
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    openShowVendorBatches() {
      this.setState({ showVendorBatchesOpen: true });
    }

    closeShowVendorBatches() {
      this.setState({ showVendorBatchesOpen: false });
    }

    // setAllProducts(product) {
    //   this.props.setDefaultOfForm('Products', product, 'purchaseReturnForm')
    // }

    selectInventoryInfo(selectedInventoryRow) {
      this.setState({selectedInventoryRow});
      let index = _.findIndex(this.props.simplifiedProducts, {'Product_id': selectedInventoryRow.Product_id });
      if (index > -1) {
        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
        this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseReturnForm');
        if((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && (!this.props.simplifiedProducts[index].NetWeight) ) {
          alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
        }
        this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
      }
    }

    // Selection -> Selection
    handleKeyPressTargetSelection(value, event) {
      if(event.keyCode == 13){
        if(value == "") {
          event.preventDefault();
          return;
        }
        this.refs[value].getRenderedComponent().refs.select.focus();
        // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    // Selection -> Input
    handleKeyPressTargetInput(value, event) {
      if(event.keyCode == 13){
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    // Input -> Input
    handleKeyPress(value, event) {
      if(event.charCode == 13){
        event.preventDefault();
        if(typeof value === 'object') {
          if(this.state.selectedInventoryRow.ProductType == 'Non-Fixed')
            ReactDOM.findDOMNode(this.refs[value[1]].getRenderedComponent().myInput.refs.input).focus();
          else
            ReactDOM.findDOMNode(this.refs[value[0]].getRenderedComponent().myInput.refs.input).focus();
        }
        else
          ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleKeyPressMove(event) {
      if(event.charCode == 13){
        event.preventDefault();
        this.moveToProductsListFromAll();
      }
    }

    // handleKeyPressMoveVendor(event) {
    //   if(event.charCode == 13){
    //     event.preventDefault();
    //     this.moveToProductsList();
    //   }
    // }

    handleOnFocus(event) {
      event.target.select();
    }

    confirmSearch() {
      this.props.fetchReturnBatch(this.props.searchType, this.props.allProducts);
      this.setState({showInventoryOpen: true});
    }

    renderPreview() {
      return (
        <div id="preview">
          <Row><Col sm={ 12 }>
            <Image src={this.state.files[0].preview} thumbnail/>
          </Col></Row>
        </div>
      )
    }

    renderWarehouse() {
      if (this.props.warehouseIsLoading) return <Spinner/> // If group is loading, show a spinner.
      else {
        let warehouseOptions = this.getWarehouseOptions();
        if(isOLG) {
          const defaultValue = {value: 1, label: 'Olong Trading Inc. '};
          return (
            <Col xs={ 12 }>
              <label><Translate value="pickup_warehouse" /><span className="asteriksReq" >*</span></label>
              <Field name="Pickup_Warehouse_id" component={Selection} matchPos="any" options={warehouseOptions} disabled={this.state.isCompleted} defaultValue={defaultValue}/>
            </Col>
          )
        }
        return (
          <Col xs={ 12 }>
            <label><Translate value="pickup_warehouse" /><span className="asteriksReq" >*</span></label>
            <Field name="Pickup_Warehouse_id" component={Selection} matchPos="any" options={warehouseOptions} disabled={this.state.isCompleted} />
          </Col>
        )
      }
    }

    getWarehouseOptions() {
      var warehouseOptions = [];
      this.props.warehouses.map(warehouse => {
        warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
      });
      return warehouseOptions;
    }
    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    handleFormSubmit = (formProps) => {
      this.setState({ dirty: false });
      // creating new
      if (!this.props.currentPurchaseReturn){
        this.props.createPurchaseReturn(formProps, Data.Selectors.getRows(this.state), this.state.isPurchaseCreditMode);
      }

      // editing existing
      else {
        if(!this.checkPermission("change_purchase_return"))
          this.props.editPurchaseReturn(formProps, Data.Selectors.getRows(this.state));
        else
          alert("You have no permission!");
      }
    }

    handleFormSubmitAndRedelivery = formProps => {
      this.setState({ dirty: false });
      // creating new
      if (!this.props.currentPurchaseReturn){
        this.props.createPurchaseReturn(formProps, Data.Selectors.getRows(this.state), this.state.isPurchaseCreditMode, isVAK && true); //isVAK only
      }
    }

    handleMiscCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.miscCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({miscCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleHandlingCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.handlingCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({handlingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleAdjustmentCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.adjustmentCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({adjustmentCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleShippingCostChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      totalPrice = parseFloat(totalPrice || 0) - parseFloat(this.state.shippingCostValue || 0) + parseFloat(event.target.value || 0);
      let discountValue = parseFloat(this.state.discountValue);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      this.setState({shippingCostValue: event.target.value, totalPrice: totalPrice, finalPrice: finalPrice});
    }

    handleDiscountChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      let taxValue = parseFloat(this.state.taxValue);
      let finalPrice = (totalPrice * (1 - parseFloat(event.target.value || 0) / 100.0) * (1 + parseFloat(taxValue || 0) / 100.0)).toFixed(2);
      // let finalPrice = (totalPrice / (1 - parseFloat(discountValue || 0) / 100.00) * (1 - parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
      this.setState({discountValue: event.target.value, finalPrice: finalPrice});
    }

    handleTaxChange(event) {
      let totalPrice = parseFloat(this.state.totalPrice);
      let discountValue = parseFloat(this.state.discountValue);
      let finalPrice = (totalPrice * (1 - parseFloat(discountValue || 0) / 100.0) * (1 + parseFloat(event.target.value || 0) / 100.0)).toFixed(2);
      // let finalPrice = (totalPrice / (1 + parseFloat(taxValue || 0) / 100.00) * (1 + parseFloat(event.target.value || 0) / 100.00)).toFixed(2);
      this.setState({taxValue: event.target.value, finalPrice: finalPrice});
    }

    completePurchaseReturn = () => {
      this.props.completePurchaseReturn(this.props.currentPurchaseReturnDetail.PurchaseReturn_id);
    }

    checkPermission(permission) {
      return false;
    }

    handleSearchTypeChange = (e) => {
      this.props.setDefaultOfForm(e.target.name, e.target.value, this.props.form);
      this.setState({ productSearchType: e.target.value });
    }
    renderTypeRadios = () => {
      return isGFD ? (
        <div className="form-group" id="search-product-by">
          <label className="col-xs-2 search-by-max-width">
            Search by:
          </label>
         <label className="col-xs-2" >
              <input type="radio" value="ProductNum" name='SearchType' onClick={this.handleSearchTypeChange}
              checked={this.props.searchType === 'ProductNum'}
                />
              <Translate value="prod_num" />
          </label>
          <label className="col-xs-2 pl">
            <input  type="radio" value="RefNum" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'RefNum'}
          />
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-xs-2" >
            <input type="radio" value="Name" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'Name'}
              />
            <Translate value="name" />
          </label>
          <label className="col-xs-2" >
            <input type="radio" value="Description" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'Description'}
             />
            <Translate value="description" />
          </label>
            <label className="col-xs-1 pl">
              <input type="radio" value="VPN" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'VPN'}
              />
              VPN
              {/* <Translate value={"VPN"} /> */}
            </label>
            <label className="col-xs-1 pl">
              <input type="radio" value="UPC" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'UPC'}
              />
              UFC
              {/* <Translate value={"UFC"} /> */}
            </label>
        </div>
      )
      :
      (
        <div className="form-group" id="search-product-by">
          <label className="col-xs-3 search-by-max-width">
            <Translate value="search_by" />
          </label>
          {!isOLG && <label className="col-xs-2" >
              <input type="radio" value="ProductNum" name='SearchType' onClick={this.handleSearchTypeChange}
              checked={this.props.searchType === 'ProductNum'}
                />
              <Translate value="prod_num" />
          </label>}
          <label className="col-xs-2 pl">
            <input  type="radio" value="RefNum" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'RefNum'}
          />
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-xs-2" >
            <input type="radio" value="Name" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'Name'}
              />
            <Translate value="name" />
          </label>
          <label className="col-xs-2" >
            <input type="radio" value="Description" name='SearchType' onClick={this.handleSearchTypeChange}
                checked={this.props.searchType === 'Description'}
             />
            <Translate value="description" />
          </label>
        </div>
      )
    }

    setPurchaseReturnBatchVisibility = (isPurchaseReturnBatchVisible = false) => this.setState({ isPurchaseReturnBatchVisible });

    handleOnSaveSuccess = () => {
      const { Review_Status, Approve_Status } = this.props.currentPurchaseReturnDetail || {};
      let setReviewCallback = null;
      let setApproveCallback = null;
      let setRecheckCallback = null;
      let isApproved = false;
      if (Review_Status !== 'Confirm' || Review_Status !== 'Pending') {
        setReviewCallback = () => {
          this.closeAlertModal(() => {
            this.handleSetReview();
          });
        };
        isApproved = true;
      }
      if (Review_Status === 'Confirm') {
        if (Approve_Status === null || Approve_Status === 'Reject') {
          setApproveCallback = () => {
            this.closeAlertModal(() => {
              this.handleSetApprove();
            });
          }
        }
        setRecheckCallback = () => {
          this.closeAlertModal(() => {
            this.handleOpenRecheck();
          })
        }
        isApproved = false;
      }
      this.setState({
        isApproved,
        alertModalVisibility: true,
        alertModalCase: 'save_with_review_and_approve',
        setReviewCallback,
        setRecheckCallback,
        setApproveCallback,
      });
    }
    handleOnReviewClick = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'confirm_review',
        setConfirmCallback: () => {
          this.closeConfirmModal(() => {
            this.handleConfirmReview()
          })
        },
        setRejectCallback: () => {
          this.closeConfirmModal(() => {
            this.handleRejectReview()
          })
        }
      })
    }
    handleOnApproveClick = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'confirm_approve',
        setConfirmCallback: () => {
          this.closeConfirmModal(() => {
            this.handleConfirmApprove()
          })
        },
        setRejectCallback: () => {
          this.closeConfirmModal(() => {
            this.handleRejectApprove()
          })
        }
      })
    }
    handleConfirmReview = () => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setReview(PurchaseReturn_id, null, 'Confirm', response => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'review_success',
          setReviewCallback: null,
          isApproved: response === 'Approved',
          setRecheckCallback: response === 'Approved' ? null : () => {
            this.closeAlertModal(() => {
              this.handleOpenRecheck();
            })
          },
          setApproveCallback: response === 'Approved' ? null : () => {
            this.closeAlertModal(() => {
              this.handleSetApprove();
            })
          }
        })
      })
    }
    handleRejectReview = () => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setReview(PurchaseReturn_id, null, 'Reject', () => {
        this.closeConfirmModal(() => {
          this.setState({
            alertModalVisibility: true,
            alertModalCase: 'reject_review',
            setReviewCallback: null,
            setRecheckCallback: null,
            setApproveCallback: null,
          });
          this.fetchPurchaseReturn();
        })
      })
    }
    handleConfirmApprove = () => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setApproval(PurchaseReturn_id, 'Confirm', () => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'approve_success',
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null
        });
        this.fetchPurchaseReturn();
      })
    }
    handleRejectApprove = () => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setApproval(PurchaseReturn_id, 'Reject', () => {
        this.closeConfirmModal(() => {
          this.setState({
            alertModalVisibility: true,
            alertModalCase: 'reject_approve',
            setReviewCallback: null,
            setRecheckCallback: null,
            setApproveCallback: null,
          });
          this.fetchPurchaseReturn();
        })
      })
    }
    handleSetReview = (reviewUserId = null) => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setReview(PurchaseReturn_id, reviewUserId, 'Pending', () => {
        this.setState({
          alertModalVisibility: true,
          alertModalCase: 'set_review_success',
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null,
        });
        this.fetchPurchaseReturn();
      })
    }
    handleSetApprove = () => {
      const { PurchaseReturn_id } = this.props.currentPurchaseReturnDetail;
      setApproval(PurchaseReturn_id, 'Pending', () => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'set_approve_success',
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null,
        });
        this.fetchPurchaseReturn();
      })
    }

    handleOpenRecheck = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'set_recheck',
        setConfirmCallback: reviewUser => {
          this.handleCloseRecheck(() => {
            this.handleSetReview(reviewUser.value);
          });
        },
        setRejectCallback: () => {
          this.handleCloseRecheck();
        }
      })
    }
    handleCloseRecheck = (callback = () => {}) => {
      this.setState({
        confirmModalVisibility: false,
        confirmModalCase: 'confirm_review',
        setConfirmCallback: null,
        setRejectCallback: null,
      }, callback)
    }
    closeAlertModal = (callback) => {
      this.setState({
        alertModalVisibility: false,
        isApproved:false,
      }, () => {
        if (callback) {
          callback();
        } else {
          browserHistory.push('/purchaseReturn');
        }
      });
    }
    closeConfirmModal = (callback = () => {}) => {
      this.setState({
        confirmModalVisibility: false,
      }, callback);
    }
    render() {
      const { handleSubmit, submitting, pristine } = this.props;
      let productInfo = this.state.productInfo;
      let convertItemPriceTranslation = (<Translate value="type" />);
      let renderPurchaseReturnHeader = <h3><Translate value="purchase_return_details" /></h3>;
      let createDialogInventoryStyle = {
        height: '750px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
        top: '50%'
      };
      const createDialogStyle = {
        width: '500px',
        height: '550px',
        marginLeft: '-15%',
      };
      const confirmDialogStyle = {
        width: '500px',
        height: '200px',
        marginLeft: '-15%'
      }
      if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...<Translate value="reading_data" /></ContentWrapper>
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
      else {
        let PONum = null;
        if(this.props.currentPurchaseOrder){
          PONum = this.props.currentPurchaseOrder.PONum;
        }
        let saveDisabled = this.props.currentPurchaseReturnDetail && this.props.currentPurchaseReturnDetail.IsFinalized;
        if (isOCM) {
          if (saveDisabled && checkPermission('set_released_sales_invoice')) {
            saveDisabled = false;
          }
        }
        if (isVAK) {
          const { Review_Status, Approve_Status, ReturnStatus } = this.props.currentPurchaseOrder || {};
          if (Review_Status === 'Confirm' && Approve_Status === 'Confirm') {
            saveDisabled = true;
          }
        }
        // let isCompleted = {isCompleted: this.state.isCompleted};
        // const printUrl = `${ROOT_URL}v1/purchase/return/print/${this.props.params.id}/?Bearer=${localStorage.getItem('token')}`;
        const { isReviewer, isApprover, Review_Status, Approve_Status, ReturnStatus } = this.props.currentPurchaseReturnDetail || {};
        return (
          <ContentWrapper>
            <form className='form-horizontal' autoComplete='off' method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit)}>
              { this.title() }
              <ButtonToolbar id="purchase-return-form-button">
                {
                  isVAK && !this.state.isPurchaseCreditMode && !this.props.currentPurchaseReturn &&
                  <Button
                    bsStyle="success"
                    type="button"
                    disabled={submitting || pristine || saveDisabled || ReturnStatus === 'Void'}
                    onClick={handleSubmit(this.handleFormSubmitAndRedelivery)}
                  >
                    <em className="fa fa-save" /><Translate value="redeliver" />
                  </Button>
                }
                <Button
                  bsStyle="success"
                  type="button"
                  disabled={submitting || pristine || saveDisabled || ReturnStatus === 'Void'}
                  onClick={handleSubmit(this.handleFormSubmit)}
                >
                  <em className="fa fa-save" />{(isSV && this.props.params.id) ? " Save & Sync QB" : <Translate value="save" />}
                </Button>
                {
                  isVAK &&
                  <Button
                    bsStyle="primary"
                    type="button"
                    disabled={submitting || !(isReviewer && Review_Status === 'Pending' && checkPermission('review_purchase_return')) || ReturnStatus === 'Void'}
                    onClick={this.handleOnReviewClick}
                  >
                    <i className="fa fa-eye"/>
                    <Translate value="mfg_review"/>
                  </Button>
                }
                {
                  isVAK &&
                  <Button
                    bsStyle="primary"
                    type="button"
                    disabled={submitting || !(isApprover && Approve_Status === 'Pending' && checkPermission('approve_purchase_return')) || ReturnStatus === 'Void'}
                    onClick={this.handleOnApproveClick}
                  >
                    <i className="fa fa-eye"/>
                    <Translate value="approval"/>
                  </Button>
                }
                {/*
                  <Button
                    bsStyle="primary"
                    type='button'
                    onClick={this.completePurchaseReturn}
                  >
                    <em className="fa fa-save marginRightStyle" /><Translate value="complete" />
                  </Button>
                */}
                {/* <Button bsStyle="success" ><em className="fa fa-envelope-o marginRightStyle" /><Translate value="email" /></Button>
                <Button bsStyle="success" ><Translate value="e_fax" /></Button> */}
                {/* <Button bsStyle="primary" href={printUrl}><em className="fa fa-print marginRightStyle" /><Translate value="print" /></Button> */}
                <SpinnerButton
                  bsStyle="primary"
                  disabled={!this.props.params.id || this.props.requestingPurchaseReturnPdf}
                  icon="fa-print"
                  translation={<Translate value="print" />}
                  loading={this.props.requestingPurchaseReturnPdf}
                  onClick={() => {
                    this.props.printPurchaseReturn(this.props.params.id);
                  }}
                />
                <Button href="/purchaseReturn" bsStyle="danger"><em className="fa fa-close"/><Translate value="cancel" /></Button>
              </ButtonToolbar>
              { (this.props.isCreating || this.props.isEditing) && <Spinner/> }
              { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
              { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
              <Grid id="purchase-return-form">
                <Row>
                  <Col sm={ 10 }>
                    <Panel className="purchase-return-vendor-info" >
                      <Row>
                        { this.renderVendorInfo(this.state.isCompleted) }
                        { this.renderBillingInfo() }
                        { this.renderReturnOrderInfo() }
                      </Row>
                    </Panel>
                    <Panel style={{height: 85}}>
                      <Row>
                        {/* Search Product by */}
                        <Col xs={ (isGFD || isBRO) ? 8 : 6 } className="p0">
                          <Col xs= { 10 }>
                            {this.renderTypeRadios()}
                          </Col>
                          <Col xs={ 10 }>
                            {
                              (this.state.isPurchaseCreditMode || isBRO) ?
                              this.renderAutoSuggest() :
                              <Field name="AllProducts" ref="allProducts" withRef={true} component={ InputField } onKeyPress={(event) => {this.openShowInventory(event)}} onFocus={this.handleOnFocus}/>
                            }
                          </Col>
                          <Col xs={2}>
                          {/* <Button
                              bsStyle="success"
                              onClick={this.confirmSearch}
                            >
                              <em className="fa fa-plus" />
                            </Button> */}
                          </Col>
                        </Col>
                        {/* doesnt work currently. may bring back later. */}
                        {/* <Col xs={ 6 } id="product-search-outputs">
                          <Col xs={ 2 }>
                            <label>
                              <Translate value="qty" />
                            </label>
                            <Field name="AllProd_Quantity" ref="allProd_Quantity" withRef={true} component={ InputField } placeholder={0} onKeyPress={(event) => {this.handleKeyPress("allProd_FOBUnitPrice", event)}} onFocus={this.handleOnFocus}/>
                          </Col>
                          <Col xs={ 2 }>
                            <label>
                              <Translate value="unit" /><span className="dollar-sign">$$</span>
                            </label>
                            <Field name="AllProd_FOBUnitPrice" ref="allProd_FOBUnitPrice" withRef={true} component={ InputField } placeholder={ "must be > 0" } onKeyPress={(event) => {this.handleKeyPress("allProd_Remark", event)}} onFocus={this.handleOnFocus}/>
                          </Col>
                          <Col xs={ 2 }>
                            <label>
                              <Translate value="net_wt" />
                            </label>
                            <Field name="Weight" component={ DisabledInputField } />
                          </Col>
                          <Col xs={ 2 }>
                            <label>
                              <Translate value="subtotal" />
                            </label> */}
                            {/* {this.renderSubtotal()} */}
                          {/* </Col>
                          <Col md ={ 4 }>
                            <label>
                              <Translate value="notation" />
                            </label>
                            <Field name="AllProd_Remark" ref="allProd_Remark" withRef={true} component={ InputField } onKeyPress={(event) => {this.handleKeyPressMove(event)}} onFocus={this.handleOnFocus}/>
                          </Col>
                        </Col> */}
                      </Row>{/* End Search Product By */}

                      {/* Inventory Details */}
                      {/* Inventory Details */}
                      {/* <Row id="inventory-details">
                        <Col xs={ 6 }>
                          <Col xs={ 4 }>
                            <label><Translate value="inventory" />:</label>
                          </Col>
                          <Col xs={ 4 }>
                            <label className="col-xs-6 inlineLabel"><Translate value="in_stock" />:</label>
                            <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.InStock:null}</span>
                          </Col>
                          <Col xs={ 4 }>
                            <label className="col-xs-6 inlineLabel"><Translate value="presale" />:</label>
                            <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.PreSale:null}</span>
                          </Col>
                        </Col>
                        <Col xs={ 6 }>
                          <Col xs={ 4 }>
                            <label className="col-xs-6 inlineLabel"><Translate value="purchased" />:</label>
                            <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.Purchased:null}</span>
                          </Col>
                          <Col xs={ 4 }>
                            <label className="col-xs-6 inlineLabel"><Translate value="min_limit" />:</label>
                            <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.ProductNum.MinStockRange:null}</span>
                          </Col>
                          <Col xs={ 4 }>
                            <label className="col-xs-6 inlineLabel"><Translate value="max_limit" />:</label>
                            <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.ProductNum.MaxStockRange:null}</span>
                          </Col>
                        </Col>
                      </Row> */}
                      {/* End Inventory */}
                      {/* End Your Purchase Order Table */}
                    </Panel>
                    <Row>
                      { this.orderHeader() }
                      <Panel className="your-return-order">
                        { this.renderProducts() }
                      </Panel>
                    </Row>
                  </Col>
                  <Col sm={2}>
                    {isVAK ? <Tabs defaultActiveKey={1} justified className="tab-width-fix">
                      <Tab eventKey={1} title={<Translate value={'return_details'}/>} className="so-details-tab">
                        {this.renderPurchaseReturnDetails()}
                      </Tab>
                      <Tab eventKey={2} title={<Translate value="action_log"/>} className="check-out-info-tab">
                        <ActionTimeline num={this.props.currentPurchaseReturnDetail !== null && this.props.currentPurchaseReturnDetail.PRNum || 'new'} module={'return'}/>
                      </Tab>
                    </Tabs> : <Panel header={renderPurchaseReturnHeader}> {this.renderPurchaseReturnDetails()}</Panel>}
                  </Col>
                  {/* <Col>
                        <Panel className="panelStyle" header={this.purchaseInformationHeader()} collapsible expanded={this.state.purchaseInformationOpen}>
                            <fieldset>
                              <Row className="marginBottomStyle">
                                <Col sm={6}>
                                    <label className="col-sm-6 marginTopStyle inlineLabel" ><Translate value="total_net_weight" /></label>
                                    <Field name="TotalNetWeight" component={ HiddenInputField } V={ this.state.totalNetWeight }/>
                                    <label className="col-sm-6 inlineLabel" style={{paddingLeft: '8px'}} >{this.state.totalNetWeight} lb</label>
                                </Col>
                                </Row>
                            </fieldset>
                            <fieldset>
                                <Row className="marginBottomStyle" >
                                  <Col sm={ 3 }><label className="col-sm-12 marginTopStyle inlineLabel" ><Translate value="misc_cost_detail" /></label></Col>
                                    <Col sm={ 9 } style={{float: "left"}}>
                                      <Field name="MiscNote" component={ InputField }/>
                                    </Col>
                                </Row>
                            </fieldset>
                        </Panel>
                    </Col> */}
                    {/* <Col sm={ 8 }>
                        <Row><Col sm={ 12 }>
                            <Link to="/purchaseReturn" className="btn btn-default"><em className="fa fa-close"/></Link>
                            <Button className="btn btn-default" disabled={ submitting || pristine }><em className="fa fa-trash"/></Button>
                            { (this.props.isCreating || this.props.isEditing) && <Spinner/> }
                            { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
                            { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
                            <Button className="btn btn-primary pull-right" disabled={ submitting || pristine } type="submit" ><em className="fa fa-save marginRightStyle" /><Translate value="save" /></Button>
                            <Button className="btn btn-primary pull-right" onClick = {() => this.completePurchaseReturn()}><em className="fa fa-save marginRightStyle" /><Translate value="complete" /></Button>
                            <Button className="btn btn-success pull-right" ><em className="fa fa-envelope-o marginRightStyle" /><Translate value="email" /></Button>
                            <Button className="btn btn-success pull-right" ><Translate value="e_fax" /></Button>
                            <Button className="btn btn-success pull-right" ><em className="fa fa-print marginRightStyle" /><Translate value="print" /></Button>
                        </Col></Row>
                        <hr/>
                        <Panel>
                            <Col>
                                <Row>
                                    <Panel header={this.returnHeader()} className="panelStyle">
                                        {this.renderVendorAddress()}
                                    </Panel>
                                </Row>
                                <Row>
                                  <Panel header={this.accountHeader()} className="panelStyle">
                                        <br/>
                                          <Col sm={ 6 }>
                                          <label className="col-sm-5 inlineLabel"><Translate value="invoice" /></label>
                                            <Col sm={ 6 }>
                                        <FieldArray name="Invoices" component={ renderInvoice } props = { {isCompleted: this.state.isCompleted} }/>
                                        </Col>
                                      </Col>
                                    </Panel>
                                </Row>
                            </Col>
                        </Panel>
                    </Col> */}
                </Row>
                {/* <button action="submit" className="btn btn-primary" disabled={ submitting || pristine } ><Translate value="submit" /></button>
                <Link to="/purchaseReturn" className="btn btn-danger buttonStyle"><Translate value="cancel" /></Link> */}
              </Grid>
              <SkyLightStateless
                dialogStyles={createDialogInventoryStyle}
                isVisible={this.state.showInventoryOpen}
                onCloseClicked={this.closeShowInventory}
                title="Select Inventory"
              >
                {/* <InventoryInfo searchValue={this.props.allProducts} searchType={this.props.searchType} searchForBatch={true}
                  closeShowInventory={this.closeShowInventory} selectInventoryInfo={this.selectInventoryInfo} setAllProducts={this.props.setAllProducts} setUnitPrice={()=>{}} form="purchaseReturnForm"/> */}
                <VendorBatches
                  moveToProductsListFromVendor={this.moveToProductsListFromVendor}
                  closeShowVendorBatches={this.closeShowInventory}
                  form="purchaseReturnForm"
                />
              </SkyLightStateless> {/* End Inventory List */}
              <SkyLightStateless
                dialogStyles={createDialogInventoryStyle}
                isVisible={this.state.showVendorBatchesOpen}
                onCloseClicked={this.closeShowVendorBatches}
                title={<Translate value="vendor_batches" />}
              >
                <VendorBatches
                  moveToProductsListFromVendor={this.moveToProductsListFromVendor}
                  closeShowVendorBatches={this.closeShowVendorBatches}
                  form="purchaseReturnForm"
                />
              </SkyLightStateless>
              <SkyLightStateless
                dialogStyles={createDialogStyle}
                isVisible={this.state.setWeightOpen}
                onCloseClicked={this.closeSetWeight}
                title="Set Product Weights"
              >
                <SetWeightModal
                  invoice
                  setWeights={this.setWeights}
                  keepLoaded={this.keepLoaded}
                  currentWeights={this.state.currentWeights}
                  closeC={this.closeSetWeight}
                  totalLoaded={this.state.totalLoaded}
                  rowChosen={this.state.rowChosen}
                  oldLoaded={this.state.oldQty}
                  BinWeight={this.state.BinWeight}
                  returnTotalWeight={this.returnTotalWeight.bind(this)}
                  editedRow={this.state.editedRow}
                />
              </SkyLightStateless>
              <PurchaseReturnBatch
                isVisible={this.state.isPurchaseReturnBatchVisible}
                setVisibility={this.setPurchaseReturnBatchVisibility}
                selectedProduct={this.state.selectedProduct}
                selectedWarehouse={this.props.selectedWarehouse}
                selectedCompany={this.props.selectedCompany}
                loadBatches={this.loadBatches}
                rows={this.state.rows}
              />
              <SkyLightStateless
                dialogStyles={confirmDialogStyle}
                isVisible={this.state.alertModalVisibility}
                onCloseClicked={() => this.closeAlertModal()}
              >
                <ConfirmActionModal
                  case={this.state.alertModalCase}
                  onConfirm={() => this.closeAlertModal()}
                  isApproved={this.state.isApproved}
                  onSetReview={this.state.setReviewCallback}
                  onSetRecheck={this.state.setRecheckCallback}
                  onSetApprove={this.state.setApproveCallback}
                />
              </SkyLightStateless>
              <SkyLightStateless
                dialogStyles={confirmDialogStyle}
                isVisible={this.state.confirmModalVisibility}
                onCloseClicked={() => this.closeConfirmModal()}
              >
                <ConfirmActionModal
                  case={this.state.confirmModalCase}
                  userOptions={this.props.userOptions}
                  onConfirm={this.state.setConfirmCallback}
                  onReject={this.state.setRejectCallback}
                  onCancel={() => this.closeConfirmModal()}
                />
              </SkyLightStateless>
            </form>
            { this.renderPrintIframe() }
        </ContentWrapper>
      )
    }
  }
}

export default withRouter(PurchaseReturnForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseReturnForm.jsx